// @flow
import { fork } from 'redux-saga/effects';
import authSignUp from './signUp';
import authSignIn from './signIn';
import refresh from './refresh';
import recoverPassword from './recoverPassword';
import resetPassword from './resetPassword';
import confirmEmail from './confirmEmail';
import checkAuth from './checkAuth';

export default function* authSaga() {
  yield fork(authSignUp);
  yield fork(authSignIn);
  yield fork(refresh);
  yield fork(recoverPassword);
  yield fork(resetPassword);
  yield fork(confirmEmail);
  yield fork(checkAuth);
}
